import { RatingFormCreateDTO } from './../../model/observation/rating-form/rating-form-create.model';
import { HttpClient } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { Inject, Injectable } from '@angular/core';
import { RatingDetailsModel } from 'src/app/model/observation/rating-form/rating-details.model';
import { RatingFormAdminAction } from 'src/app/model/observation/rating-form/admin-action.model';
@Injectable()
export class RatingFormApi extends BaseApi {






    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getDetails(userId: string, ratingId: string) {
        return this.http.get(this.baseUri + '/observation/ratingform/' + ratingId, {});
    }

    createRatingForm(model:RatingFormCreateDTO) {
      return this.http.post(this.baseUri + '/observation/ratingform' , model, { responseType: "text" });
    }

    saveRatingForm(model: RatingDetailsModel) {
      return this.http.post(this.baseUri + '/observation/ratingform/save' , model, { responseType: "text" });
    }

    attachSignature(ratingId:string, location: number) {
      return this.http.post(this.baseUri + `/observation/ratingform/sign/${ratingId}/${location}` , {});
    }

    removeSignature(ratingId:string, location: number) {
      return this.http.delete(this.baseUri + `/observation/ratingform/sign/${ratingId}/${location}` );
    }

    getAdminActions(increment:number, index:number) {
      return this.http.get(this.baseUri + `/observation/ratingform/management/actions/${increment}/${index}` );
    }

    createAdminAction(action: RatingFormAdminAction) {
      return this.http.post(this.baseUri + `/observation/ratingform/management/create-action`, action, { responseType: "text" });
    }

}
